module.exports = __webpack_public_path__ + "img/mango_title.579f00a9.svg";